<template>
<div class="category-selector">
  <div class="category-selector__label">
    {{label}}
  </div>
  <ul class="category-list">
    <li class="category-list__item" v-for="item in items" :key="item" @click="$emit('item-click', item)">{{title(item)}}</li>
  </ul>
</div>
</template>

<script>
export default {
  name: 'CategorySelector',
  props: ['label'],
  data: function () {
    return {
      items: ['ak1', 'ak2', 'ak3', 'ak4', 'ak5', 'ak6']
    }
  },
  methods: {
    title (item) {
      return item.substr(2, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.category-selector {
  margin-top: 50px;

  text-align: center;

  .category-selector__label {
    flex: 1;

    margin-bottom: 20px;

    font-size: 18px;
    font-weight: bold;
  }

  .category-list {
    display: flex;
    flex-direction: row;
    justify-content: center;

    padding: 0;

    .category-list__item {
      margin-right: 8px;
      padding: 9px 14px 7px;

      cursor: pointer;
      transition: box-shadow 100ms, transform 100ms;

      color: #004f84;
      border: 1px solid #509dd1;
      border-radius: 3px;
      background-color: rgba(206,224,239,.2);

      font-size: 14px;

      &:hover {
          z-index: 1;

          transform: scale(1.07, 1.07);

          background-color: #fff;
          box-shadow: 3px 3px 10px rgba(#5289C1, 0.3);
      }

      &::before {
        content: '';
      }
    }
  }
}

</style>



// WEBPACK FOOTER //
// src/components/CategorySelector.vue